export function documentIsDefined(): boolean {
  return typeof document !== `undefined`;
}
